// @flow
import React, { Component, Fragment } from 'react';
import { CommonActions, DisplayActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import SaveProductCardList from 'components/saves/SaveProductCardList/SaveProductCardList';
import type { ProductItem } from 'store/modules/display';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';
import QuestionModal from 'components/common/QuestionModal/QuestionModal';

type Props = {
  username: ?string,
  products: ?(ProductItem[]),
  prefetched: ?(ProductItem[]),
  prefetching: boolean,
  loading: boolean,
  hasEnded: boolean,
  removeId: ?string,
  ask: boolean,
};

class SaveProductCardListContainer extends Component<Props> {
  prevCursor: ?string = null;

  initialize = async () => {
    if (!this.props.username) return;
    try {
      await DisplayActions.getTempProducts({
        username: this.props.username,
      });
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.username && this.props.username) {
      this.initialize();
    }
  }

  prefetch = async () => {
    const { products, prefetching, loading, hasEnded, prefetched, username } = this.props;
    if (loading || prefetching || !products || !username) return;
    if (products.length === 0) return;
    const { id: lastId } = products[products.length - 1];
    if (prefetched) {
      DisplayActions.revealPrefetched('temp');
      await Promise.resolve();
    }

    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;

    if (hasEnded) return;
    try {
      await DisplayActions.prefetchTempProducts({
        cursor: lastId,
        username,
      });
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  onAskRemove = (productId: string) => {
    CommonActions.askRemove(productId);
  };

  onConfirmRemove = async () => {
    const { removeId } = this.props;
    if (!removeId) return;
    CommonActions.removeProduct(removeId);
    DisplayActions.removeTempProduct(removeId);
    CommonActions.closeRemove();
  };

  onCancelRemove = () => {
    CommonActions.closeRemove();
  };

  render() {
    const { products, ask } = this.props;
    return (
      <Fragment>
        <SaveProductCardList products={products} onAskRemove={this.onAskRemove} />
        <QuestionModal
          open={ask}
          title="임시 상품 삭제"
          description="이 상품을 정말로 삭제하시겠습니까?"
          confirmText="삭제"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
        />
      </Fragment>
    );
  }
}

export default connect(
  ({ user, display, pender, common }: State) => ({
    username: user.user && user.user.username,
    products: display.temp.products,
    prefetched: display.temp.prefetched,
    prefetching: pender.pending['display/PREFETCH_TEMP_PRODUCTS'],
    loading: pender.pending['display/GET_TEMP_PRODUCTS'],
    hasEnded: display.temp.end,
    removeId: common.saves.removeId,
    ask: common.saves.ask,
  }),
  () => ({}),
)(SaveProductCardListContainer);



// WEBPACK FOOTER //
// ./src/containers/saves/SaveProductCardListContainer.js